import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

function toOptionalCents(value: number | null | undefined): number | null | undefined {
  if (value == null) {
    return value;
  }

  return toCents(Number(value));
}

export class UpdatePointPriceConfigurationDto {
  @Expose()
  points?: number;

  @Expose()
  @Transform(({ value }) => toOptionalCents(value))
  technicianPriceCents?: number;

  @Expose()
  @Transform(({ value }) => toOptionalCents(value))
  driverPriceCents?: number;

  @Expose()
  @Transform(({ value }) => toOptionalCents(value))
  assistantPriceCents?: number;
}
